import {
    useMemo,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import {
    ArchiveButton, useArchive, ArchiveConfirmationDialog,
} from 'app/shared-components/Archive'

import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import request from 'app/requests/Account.requests'
import AccountForm from '../AccountForm'
import useGetAccount from '../../hooks/useGetAccount'

type Props = {
    id: number,
    disabled?: boolean
}

const defaultProps = {
    disabled: false,
}

const AccountUpdate = ({
    id,
    disabled,
}: Props) => {
    const {
        Accounts: AccountsRoutes,
    } = useAccountManagementRoutes()
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetAccount(id)

    const archive = useArchive({
        requestParamFn: data?.archived ? request.restore : request.archive,
        notificationId: 'AccountUpdateDto',
        title: 'Account',
        data,
        redirectionAfterSuccess: generateSkyNetLink({
            domainPath: AccountsRoutes.path,
        }),
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        archive,
        data?.archived,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <AccountForm
                    onSuccess={invalidate}
                    data={data}
                    disabled={disabled}
                    requestParam={request.update({
                        id,
                    })}
                    customButtons={customButtons}
                />
                <ArchiveConfirmationDialog
                    title="Account"
                    openConfirmDialog={archive.openConfirmDialog}
                    handleClose={archive.handleArchiveRestoreConfirm}
                    archived={data?.archived}
                />
            </>
        </StatusHandler>
    )
}

AccountUpdate.defaultProps = defaultProps

export default AccountUpdate
